import { guidePillHtml } from "../../elements/pill/component.js";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { validate } from "../../helpers/validate.js";
import { attributesPillSchema } from "./attributes.js";
import { PillMdx } from "./component.mdx.js";
const scalarPill = {
  name: "scalar-pill",
  tagName: "scalar-pill",
  tiptapName: "pill",
  attributeTransform: (_, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    return validate(attributesPillSchema, attrs);
  },
  render: async (props) => {
    const transformed = scalarPill.attributeTransform("", props);
    return transformed ? guidePillHtml(transformed) : "";
  }
};
export {
  PillMdx,
  scalarPill
};
//# sourceMappingURL=index.js.map
